"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const react_1 = __importStar(require("react"));
const useOnClickOutside_1 = require("../utils/hooks/useOnClickOutside");
exports.Select = (0, react_1.forwardRef)(({ options, onChange, className, checked, scroll, selectAriaLabel, defaultValue = '', defaultLabel, error, icon, disabled, ...rest }, ref // Add this ref parameter
) => {
    const customRef = (0, react_1.useRef)(null);
    const listRef = (0, react_1.useRef)(null);
    const firstListItemRef = (0, react_1.useRef)(null);
    const [toggle, setToggle] = (0, react_1.useState)(false);
    const getLabel = options.find(item => item.optionval === defaultValue)?.optionname ?? '';
    const [active, setActive] = (0, react_1.useState)(getLabel);
    (0, react_1.useEffect)(() => {
        setActive(getLabel);
    }, [getLabel]);
    const onHandleKeyDown = (e) => {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            setToggle((prev) => !prev);
            setTimeout(() => {
                firstListItemRef.current?.focus();
            }, 0);
        }
    };
    const onItemHandleKeyDown = (e, value) => {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            const label = options.find(item => item.optionval === value)?.optionname ?? '';
            setActive(label);
            onChange?.(value);
            setToggle(false);
        }
    };
    const handleItemClick = (value) => {
        const label = options.find(item => item.optionval === value)?.optionname ?? '';
        setActive(label);
        onChange?.(value);
        setToggle(false);
    };
    const handleToggle = () => {
        listRef.current?.focus();
        setToggle(prev => !prev);
    };
    (0, useOnClickOutside_1.useOnClickOutside)(customRef, () => setToggle(false));
    const handleKeyDown = (e, index) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            const direction = e.key === 'ArrowDown' ? 1 : -1;
            const nextIndex = (index + direction + options.length) % options.length;
            const nextElement = listRef.current?.querySelectorAll('li')[nextIndex];
            nextElement?.focus();
        }
        if (e.key === 'Tab') {
            const isLastItem = index === options.length - 1;
            const isFirstItem = index === 0;
            if ((!e.shiftKey && isLastItem) || (e.shiftKey && isFirstItem)) {
                setToggle(false);
            }
        }
    };
    return (react_1.default.createElement("div", { ref: (node) => {
            customRef.current = node;
            if (typeof ref === 'function')
                ref(node);
            else if (ref)
                ref.current = node;
        }, className: `relative ${className}`, ...rest },
        react_1.default.createElement("button", { tabIndex: 0, onKeyDown: onHandleKeyDown, onClick: handleToggle, "aria-expanded": toggle, "aria-label": selectAriaLabel, type: "button", disabled: disabled, className: `${error ? 'border-brandError' : 'border-[#d6d6d6]'} ${disabled ? 'cursor-not-allowed border-grey300 bg-grey300 opacity-50' : ''} w-full text-left border rounded-[4px] pt-[15px] pb-[12px] pl-[20px] pr-[40px] text-brandBlack text-[14px] leading-normal relative` },
            react_1.default.createElement("span", { className: "line-clamp-1" }, defaultLabel && active === defaultValue ? defaultLabel : active),
            react_1.default.createElement("span", { className: "absolute top-1/2 -translate-y-1/2 right-[20px]" }, icon || (react_1.default.createElement("span", { className: `${toggle ? 'icon-up-arrow' : 'icon-down-arrow'} w-[12px] text-[10px] text-brandBlack` })))),
        react_1.default.createElement("ul", { role: "listbox", ref: listRef, className: `shadow-[0_4px_30px_0px_rgba(0,0,0,0.07)] rounded-[5px] z-10 bg-brandWhite py-[0px] absolute left-0 top-full w-full ${scroll ? 'overflow-auto max-h-[200px] scroll-bar-grey' : 'overflow-hidden '} ${toggle ? 'block' : 'hidden'}` }, options.map((item, key) => (react_1.default.createElement("li", { role: "option", "aria-selected": active === item.optionname, tabIndex: 0, key: item.optionval, "data-value": item.optionval, onClick: () => handleItemClick(item.optionval), onKeyDown: (e) => {
                handleKeyDown(e, key);
                onItemHandleKeyDown(e, item.optionval);
            }, ref: key === 0 ? firstListItemRef : null, className: `tab flex gap-3 items-center text-base text-brandBlack py-2 px-4 hover:bg-grey300 hover:text-brandBlack cursor-pointer 
                            ${active === item.optionname ? 'bg-grey300' : ''}` },
            checked && active === item.optionname && (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "13", viewBox: "0 0 18 13", fill: "none" },
                react_1.default.createElement("path", { d: "M6.55156 12.9996L0.851562 7.29961L2.27656 5.87461L6.55156 10.1496L15.7266 0.974609L17.1516 2.39961L6.55156 12.9996Z", fill: "black" }))),
            item.optionname))))));
});
